"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAxios = void 0;

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _axiosFetchBridge = require("@insided/shared/services/axios-bridge/axios-fetch-bridge");

// eslint-disable-next-line no-restricted-imports
var initializeAxios = function initializeAxios() {
  Object.assign(_axiosFetchBridge.fetchDefaults.headers, {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': (0, _csrfToken.csrfToken)()
  });

  _axiosFetchBridge.requestInterceptors.push(function (config) {
    // Set baseURL for embedded widgets at request time.
    var appState = (0, _globals.default)('appState');

    if (!config.baseURL && appState !== null && appState !== void 0 && appState.isEmbedded) {
      var _appState$baseUrl;

      config.baseURL = (_appState$baseUrl = appState.baseUrl) !== null && _appState$baseUrl !== void 0 ? _appState$baseUrl : (0, _globals.default)('communityUrl');
    }

    if (config.url && !config.baseURL) {
      var _resolveUrl;

      config.url = (_resolveUrl = (0, _absoluteUrlRuntime.resolveUrl)(config.url)) !== null && _resolveUrl !== void 0 ? _resolveUrl : config.url;
    }

    return config;
  });
};

exports.initializeAxios = initializeAxios;